<app-card>
    <div class="row">
        <app-form-field [required]="true" [sizeLg]="isSimple ? 6 : 3" [sizeXl]="isSimple ? 8 : 3" label="Produit">
            <app-product-select-filter #productSelectFilter
                                       (_onSingleSelectionChange)="productChanged($event)"
                                       [parentFormGroup]="parentFormGroup"
                                       [typeValue]="productType"
                                       [newItemModalOptions]="productModalOption"
                                       parentFormControlName="productId"></app-product-select-filter>
        </app-form-field>
        <app-form-field [required]="true" label="Quantité" sizeLg="2" sizeXl="1">
            <app-number-input [parentFormGroup]="parentFormGroup" parentFormControlName="quantity"></app-number-input>
        </app-form-field>
        <app-form-field *ngIf="!isSimple" [required]="true" label="% TVA" sizeLg="2" sizeXl="1">
            <app-number-input [maxValue]="100" [parentFormGroup]="parentFormGroup" parentFormControlName="taxPercentage"
                              [decimalDigits]="2" unit="%"></app-number-input>
        </app-form-field>
        <app-form-field *ngIf="!isSimple" [required]="true" label="PU HTVA" sizeLg="2" sizeXl="2">
            <app-amount-input [parentFormGroup]="parentFormGroup" parentFormControlName="unitPriceVatExcluded"
                              unit="€ HTVA"></app-amount-input>
        </app-form-field>
        <app-form-field [required]="true" label="PU TTC" sizeLg="2" sizeXl="2">
            <app-amount-input [parentFormGroup]="parentFormGroup" parentFormControlName="unitPriceVatIncluded"
                              unit="€ TTC"></app-amount-input>
        </app-form-field>
        <!-- <app-form-field *ngIf="isSimple" [required]="true" label="Total" sizeLg="2" sizeXl="2">
            <app-amount-input [parentFormGroup]="parentFormGroup" parentFormControlName="totalPriceVatExcluded"
                              unit="€ HTVA"></app-amount-input>
        </app-form-field> -->
        <app-form-field [required]="true" label="Total" sizeLg="2" sizeXl="1">
            <app-amount-input [parentFormGroup]="parentFormGroup" parentFormControlName="totalPriceVatIncluded"
                              unit="€ TTC"></app-amount-input>
        </app-form-field>
    </div>
</app-card>